'use client'

import { useEffect } from 'react'
import { useRouter } from 'next/navigation'
import { useApp } from '@/context/AppContext'

export default function Home() {
  const { session } = useApp()
  const router = useRouter()

  useEffect(() => {
    if (session) router.replace('/dashboard')
    else router.replace('/login')
  }, [session, router])

  return (
    <div className="min-h-screen flex items-center justify-center bg-indigo-600">
      <div className="w-10 h-10 border-4 border-white border-t-transparent rounded-full animate-spin" />
    </div>
  )
}
